<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="520px" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="段位名称:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.levelName" auto-complete="off" class="formItem" size="small"
					maxLength="150" />
			</el-form-item>
			<el-form-item label="段位分值:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.scoreNum" auto-complete="off" class="formItem" size="small" maxLength="50" @input="handleNum('scoreNum',addForm)"/>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				levelName: '',
				scoreNum: '',
				addTime: '',

			},
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initData() {
			this.$axios.get("/exercise/getlevelinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if(this.addForm.id<=0){
						this.addForm.scoreNum=''
					}
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/exercise/levelinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	}
};
</script>

<style lang="less" scoped></style>
